export const defaultDateFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
